import { ConversationCard, RecirculationSlider } from 'open-modules/cbcrc/component/recirculationCards'
import { component, demoFile, CLICK, story } from 'system/demo'

demoFile('open-modules/cbcrc/component/recirculationCards', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=6312-22463&t=ulUnkS0T6jFNKQyd-1'
})

const recirculationCollections = {
    derived_relatedQuestionPreview: [
        { key: 'question-1', commentPreview: { from: 'b', text: 'Random comment', time: 1733775285001 }, participantCount: 2 },
        { key: 'question-2', commentPreview: { from: 'a', text: 'Some comment', time: 1733775285001 }, participantCount: 3 },
        { key: 'question-3', commentPreview: { from: 'c', text: 'Some other comment', time: 1733775285001 }, participantCount: 5 }
    ],
    relatedConversations: [
        { key: 'question-1', id: 'question-1', from: 'a', text: 'Is Godzilla good?' },
        { key: 'question-2', id: 'question-2', from: 'b', text: 'Is Kong bad?' },
        { key: 'question-3', id: 'question-3', from: 'c', text: 'Would you watch Gozilla vs Kong?' }
    ]
}

component('ConversationCard', ConversationCard, {
    args: { id: 'question-1', text: 'Is King Kong Bad?', singleCard: true },
    state: { collections: recirculationCollections }
}, [
    story('Click on card', [CLICK('conversation-card-question-1')])
])

component('RecirculationSlider', RecirculationSlider, {
    args: { cardsData: recirculationCollections.relatedConversations, controls: true },
    state: { collections: recirculationCollections }
}, [
    story('Navigate in the slider', [CLICK('Next'), CLICK('Next'), CLICK('Previous')])
])
